"use strict";
// UI language only. No date, chart, person or prompt values enter this store.
const SUPPORTED = ["es", "en"];
const valid = value => SUPPORTED.includes(value);
function createLanguageStore({ storage, request, apply = () => {}, notify = () => {} }) {
  const readLocal = () => { try { const x = storage?.getItem("astroAppLanguage"); return valid(x) ? x : "es"; } catch { return "es"; } };
  const writeLocal = value => { try { storage?.setItem("astroAppLanguage", value); } catch {} };
  let language = readLocal(), saved = null, owner = null, epoch = 0, revision = 0, queue = Promise.resolve();
  function publish(value) { language = value; apply(value); }
  async function setUser(id) {
    const turn = ++epoch;
    owner = id || null; saved = null; revision++; notify('');
    if (!owner) { publish(readLocal()); return; }
    const at = revision;
    try {
      const result = await request("GET");
      if (turn !== epoch || at !== revision) return;
      saved = valid(result.language) ? result.language : null;
      publish(saved || readLocal());
    } catch { if (turn === epoch && at === revision) { publish(readLocal()); notify("loadError"); } }
  }
  function choose(value) {
    if (!valid(value)) return Promise.reject(new Error("INVALID_APP_LANGUAGE"));
    const turn = epoch, serial = ++revision;
    publish(value);
    if (!owner) { writeLocal(value); notify("saved"); return Promise.resolve(true); }
    notify("saving");
    // Serialize requests, not just responses: the last explicit choice must also
    // be the last value stored by the server. Pending account changes invalidate work.
    const operation = queue.catch(() => {}).then(async () => {
      if (turn !== epoch || serial !== revision) return false;
      try {
        const result = await request("PATCH", value);
        if (turn !== epoch) return false;
        if (result.language !== value) throw new Error("INVALID_LANGUAGE_RESPONSE");
        saved = value;
        if (serial === revision) notify("saved");
        return true;
      } catch {
        if (turn === epoch && serial === revision) { publish(saved || readLocal()); notify("saveError"); }
        return false;
      }
    });
    queue = operation;
    return operation;
  }
  return { setUser, choose, get language() { return language; }, get owner() { return owner; }, supported: SUPPORTED };
}
module.exports = { createLanguageStore, valid };
